export default __webpack_public_path__ + "static/media/reservation-form.5790ecf0.png";